<mat-form-field [ngClass]="(positionField === field && onBuilder) ? 'active-control' : ''">
    <mat-label>{{formInfos.name}}</mat-label>
    <mat-select [(ngModel)]="value" (ngModelChange)="selectValidator($event)" (blur)="touch($event)">
        <mat-option>--</mat-option>
        <mat-option *ngFor="let option of formInfos.options" [value]="option">
            {{option}}
        </mat-option>
    </mat-select>
    <mat-hint *ngIf="errorMessage">{{errorMessage}}</mat-hint>
</mat-form-field>